import { Vector2 } from 'three';
import vertexShader from './coverageLineShader.vert';
import fragmentShader from './coverageLineShader.frag';

/**
 * Sobel Edge Detection (see https://youtu.be/uihBwtPIBxM)
 * ref: https://github.com/mrdoob/three.js/blob/master/examples/jsm/shaders/SobelOperatorShader.js
 */

export const CoverageLineSeparatorShader = {
  name: 'CoverageLineSeparatorShader',
  uniforms: {
    tDiffuse: { value: null },
    resolution: { value: new Vector2() },
  },
  vertexShader,
  fragmentShader,
};
